const styleInput = {
    borderWidth: 1, 
    width: "100%", 
    padding: 10, 
    borderRadius: 4, 
    borderColor: "#999"
}

export {
    styleInput
}